var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgLevel12 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  style: {
    fillRule: "nonzero",
    clipRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  },
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeWidth: 0.5,
  d: "M1 16h6v8H1zM9 8h6v16H9z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.5,
  d: "M17 .25h6V24h-6z"
})));
export default SvgLevel12;